// TODO: geojson类型补充
export type GeoJSON = any;

export type TopoJSON = any;

export type GeoSourceType = GeoJSON | TopoJSON;
